import { styled } from '@mui/material';

export const ReportsHeatmapSectionMapContainer = styled('div')({
  width: '100%',
  height: '100%',

  '& .mapboxgl-map': {
    borderRadius: 10,
  },
});
